var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadNow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mx3bj5ibca",
    d: "M0 0L40 0 40 50 0 50z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#60C090",
    d: "M12.399 37.57l6.243 6.046 10.96-10.61-2.708-2.622-7.86 7.61c-.22.212-.564.212-.784 0l-3.144-3.045-2.707 2.622zM18.642 45c-.14 0-.282-.053-.392-.16l-7.072-6.847c-.114-.11-.178-.263-.178-.422 0-.16.064-.313.178-.423l3.536-3.424c.22-.212.565-.212.784 0l3.144 3.045 7.86-7.61c.22-.212.564-.212.784 0l3.536 3.424c.114.11.178.263.178.423 0 .16-.064.312-.178.422L19.035 44.84c-.11.107-.251.16-.393.16z",
    transform: "translate(-621 -307) translate(362 168) translate(219 115) translate(40 24)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-621 -307) translate(362 168) translate(219 115) translate(40 24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m1emcogehb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mx3bj5ibca"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#777D87",
    d: "M9.99 24.456h14.132c.314 0 .57-.254.57-.567 0-.312-.256-.566-.57-.566H9.99c-.314 0-.57.254-.57.566 0 .313.256.567.57.567zm0-4.443h20.02c.314 0 .57-.253.57-.566 0-.313-.256-.567-.57-.567H9.99c-.314 0-.57.254-.57.567 0 .313.256.566.57.566zm0-4.442h20.02c.314 0 .57-.254.57-.567 0-.312-.256-.566-.57-.566H9.99c-.314 0-.57.254-.57.566 0 .313.256.567.57.567zm-6.457-8.34c0 .312.255.566.57.566h3.532c.314 0 .57-.254.57-.567V3.898c0-.312-.256-.566-.57-.566-.314 0-.57.254-.57.566v2.766H4.103c-.314 0-.57.253-.57.566zM38.86 48.866H1.14V5.253l4.368-4.12H38.86v47.734zM39.431 0H5.28c-.146 0-.286.056-.392.155L.178 4.598C.064 4.705 0 4.853 0 5.009v44.424c0 .313.255.567.57.567h38.86c.315 0 .57-.254.57-.567V.567C40 .254 39.745 0 39.43 0z",
    mask: "url(#m1emcogehb)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadNow);
export default __webpack_public_path__ + "static/media/icon-upload-now.c23046a291c4d7f300fc35693deeb36f.svg";
export { ForwardRef as ReactComponent };